import { defineStore } from 'pinia';
import useGraphClient from '@/clients/graphClient.js';
import { computed, onMounted, ref } from 'vue';

export const useDarkMode = defineStore(
  'darkModeStore',
  () => {
    const isDarkMode = ref(false);

    const applyClass = () => {
      if (isDarkMode.value) {
        document.documentElement.classList.add('app-dark');
      } else {
        document.documentElement.classList.remove('app-dark');
      }
    };

    const toggleDarkMode = (value = null) => {
      isDarkMode.value = value === null ? !isDarkMode.value : value;

      applyClass();
    };

    onMounted(() => {
      applyClass();
    });

    return {
      toggleDarkMode,
      isDarkMode
    };
  },
  { persist: true }
);
